class Logger {
  constructor (context = '') {
    this.context = context
    this.enabled = !process.static && (process.client || process.env.ENVIRONMENT_NAME !== 'production')
  }

  create (context) {
    const instance = { ...this }
    Object.setPrototypeOf(instance, this)
    instance.setContext(context)
    return instance
  }

  debug (message, context) {
    if (!this.enabled) return

    context = context || this.context
    const contextStyling = this.getBadgeStyling(context)
    
    // Make message iterable
    if (message[Symbol.iterator] !== 'function') message = [message]

    console.log(`%c[${context}]`, contextStyling, ...message)
  }

  error (error, context) {
    if (!this.enabled) return
    
    context = context || this.context
    const contextStyling = this.getBadgeStyling(context)

    console.log(`%c[${context}]`, contextStyling, '[ERROR]')
    console.error(error)
  }

  setContext (context) {
    this.context = context
  }

  getBadgeStyling (str) {
    if (!str) return ''
    return `background-color: #${this.getBackgroundColour(str)}; color: ${this.getTextColour(str)}; border-radius: 4px; padding: 2px;`
  }

  getBackgroundColour (str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    const c = (hash & 0x00FFFFFF).toString(16).toUpperCase()
    return '00000'.substring(0, 6 - c.length) + c
  }

  getTextColour (str) {
    const hex = this.getBackgroundColour(str)
    const r = parseInt(hex.substr(0, 2), 16)
    const g = parseInt(hex.substr(2, 2), 16)
    const b = parseInt(hex.substr(4, 2), 16)
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
    return (yiq >= 128) ? 'black' : 'white'
  }
}

export { Logger }
export const logger = new Logger()

export default (context, inject) => {
  inject('log', logger)
}